import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';

const isValid = (subject, imports) => {
  if (!subject.import_id) {
    return true;
  }

  const item = imports.find(({ id }) => id === subject.import_id);

  if (!item) {
    return false;
  }

  if (
    subject.section_id &&
    !item.sections.some(({ id }) => id === subject.section_id)
  ) {
    return false;
  }

  return true;
};

const SectionValidator = ({ subject, onValidityChange }) => {
  const { data, isSuccess } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    onValidityChange(isValid(subject, data.data));
  }, [isSuccess, data, subject, onValidityChange]);

  return null;
};

SectionValidator.propTypes = {
  subject: PropTypes.object.isRequired,
  onValidityChange: PropTypes.func.isRequired
};

export default SectionValidator;
